import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Timer from 'react-compound-timer';
import useHeartbeat from '../../Utils/useHeartbeat';
import { setTimerExpLevel, updateOverallTimer } from '../../store/actions/AssessmentActions';

const OverallTimer = ({ submitTest, assessmentId }) => {
  const remainingTime = useSelector(state => state.assessment.remainingTime);
  const timerWarnLevel = useSelector(state => state.assessment.timerWarnLevel);
  const dispatch = useDispatch();

  useHeartbeat(assessmentId);

  useMemo(() => {
    if (remainingTime <= 0) {
      submitTest(assessmentId, true);
      dispatch(updateOverallTimer(NaN));
    }
  }, [remainingTime, assessmentId]);

  if (isNaN(remainingTime)) {
    return <span>00:00:00</span>;
  } else if (remainingTime <= 0) {
    return <span>Expired</span>;
  } else {
    const initialTimeMs = remainingTime * 1000;
    return (
      <span className={`timer-${timerWarnLevel || 'green'}`}>
        <Timer
          key={`overall-timer-${remainingTime}`}
          initialTime={initialTimeMs}
          direction="backward"
          formatValue={value => `${value < 10 ? `0${value}` : value}`}
          checkpoints={[
            {
              time: Math.max(0, initialTimeMs - 0 * 60 * 1000),
              callback: () => submitTest(assessmentId, true),
            },
          ]}
        >
          {() => (
            <React.Fragment>
              <Timer.Hours /> : <Timer.Minutes /> : <Timer.Seconds />
            </React.Fragment>
          )}
        </Timer>
      </span>
    );
  }
};

export default OverallTimer;
